import React from 'react';
import ActionBar from '../../layout/ActionBar';
import { usePageTitle } from '../../../util/pageTitle';

export interface ReportPageProps {
  /** Page title (breadcrumb; "Reports" is appended) */
  title: string;
  children: React.ReactNode;
}

/**
 * Simple report page layout: sets page title, renders ActionBar and children.
 * Use for reports that don't need a month/week switcher.
 */
function ReportPage({ title, children }: ReportPageProps) {
  usePageTitle([title, 'Reports']);
  return (
    <>
      <ActionBar />
      {children}
    </>
  );
}

export default ReportPage;
